import { CURRENT_AVAILABLE_GROUPS, useAuthContext, useHasAuthGroup } from 'providers/auth';

/**
 * Whether this user may create a campaign and walk the builder.
 *
 * router.tsx mounts `/campaigns/create` and the builder on this, so every surface that links or
 * redirects there has to gate on the same value — a link to an unmounted route resolves instead as
 * `/campaigns/:campaignId` with an id of "create".
 *
 * Internal users are excluded: `createExternalCampaign` takes the company from `x-company-id` and
 * rejects a caller without one.
 */
export const useCanCreateCampaigns = (): boolean => {
  const { isInternal } = useAuthContext();
  const isCustomerAdmin = useHasAuthGroup(CURRENT_AVAILABLE_GROUPS.CustomerAdmin);
  return !isInternal && isCustomerAdmin;
};
